import { SupportActionTypes } from "models/actionTypes/supportActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const supportCommentAdded = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_COMMENT_ADDED,
    payload: supportId,
  };
};

export const supportTicketConfirmed = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_CONFIRM_RESOLVED,
    payload: supportId,
  };
};

export const supportResolved = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_RESOLVED,
    payload: supportId,
  };
};

export const supportResponseSubmitted = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_RESPONSE_SUBMITTED,
    payload: supportId,
  };
};

export const supportForwarded = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_FORWARDED,
    payload: supportId,
  };
};

export const supportSnoozed = (supportId: number): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_FORWARDED,
    payload: supportId,
  };
};

export const supportRated = (supportIssue: WintSuperkollAPIModel.SupportIssue): SupportActionTypes => {
  return {
    type: ReduxConstants.SupportActions.SUPPORT_RATED,
    payload: supportIssue,
  };
};
